import * as React from 'react';
import '../css/checkout.comp.css';

const URL_SESSION = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_API_URL_DEV : process.env.REACT_APP_API_URL_PROD;

const ProductDisplay = (): JSX.Element => (
  <div className="checkout-container">
    <section className="checkout-section">
      <div className="product">
        <Logo />
        <div className="description">
          <h3 className="checkout-title">Subscripción a Lista Negra del SAT</h3>
          <h5 className="checkout-subtitle">$100.00 MXN / mes</h5>
        </div>
      </div>
      <form action={URL_SESSION + "create-checkout-session"} method="POST">
        {/* Add a hidden field with the lookup_key of your Price */}
        <input type="hidden" name="lookup_key" value="10" />
        <button className="checkout-button" id="checkout-and-portal-button" type="submit">
          Pagar
        </button>
      </form>
      <div className="stripe-legend">
        <span>Powered by Stripe</span>
      </div>
    </section>
  </div>
);

interface SuccessDisplayProps {
  sessionId: string;
}

const SuccessDisplay = ({ sessionId }: SuccessDisplayProps): JSX.Element => {
  return (
    <div className="checkout-container">
      <section className="checkout-section">
        <div className="product Box-root">
          <Logo />
          <div className="description Box-root">
            <h3 className="checkout-title">Subscripción a Lista Negra del SAT exitosa!</h3>
            <p>Al finalizar tu suscripción, recibiras un api key y podrás acceder a todas las funcionalidades disponibles.</p>
          </div>
        </div>
        <form action={URL_SESSION + "create-portal-session"} method="POST">
          <input
            type="hidden"
            id="session-id"
            name="session_id"
            value={sessionId}
          />
          <button className="checkout-button" id="checkout-and-portal-button" type="submit">
            Gestionar tu información de facturación
          </button>
        </form>
        <div className="stripe-legend">
          <span>Powered by Stripe</span>
        </div>
      </section>
    </div>
  );
};

interface MessageProps {
  message: string;
}

const Message = ({ message }: MessageProps): JSX.Element => (
  <div className="checkout-container">
    <section className="checkout-section">
      <p className="checkout-message">{message}</p>
    </section>
  </div>
);

interface CheckoutState {
  message: string;
  success: boolean;
  sessionId: string;
}

class Checkout extends React.Component<{}, CheckoutState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      message: '',
      success: false,
      sessionId: ''
    };
  }

  componentDidMount(): void {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);

    if (query.get('success')) {
      this.setState({
        success: true,
        sessionId: query.get('session_id') || ''
      });
    }

    if (query.get('canceled')) {
      this.setState({
        success: false,
        message: "Orden cancelada."
      });
    }
  }

  render(): JSX.Element {
    const { success, message, sessionId } = this.state;

    if (!success && message === '') {
      return <ProductDisplay />;
    } else if (success && sessionId !== '') {
      return <SuccessDisplay sessionId={sessionId} />;
    } else {
      return <Message message={message} />;
    }
  }
}

export default Checkout;

const Logo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="14px"
    height="16px"
    viewBox="0 0 14 16"
    version="1.1"
  >
    <defs />
    <g id="Flow" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="0-Default"
        transform="translate(-121.000000, -40.000000)"
        fill="#E184DF"
      >
        <path
          d="M127,50 L126,50 C123.238576,50 121,47.7614237 121,45 C121,42.2385763 123.238576,40 126,40 L135,40 L135,56 L133,56 L133,42 L129,42 L129,56 L127,56 L127,50 Z M127,48 L127,42 L126,42 C124.343146,42 123,43.3431458 123,45 C123,46.6568542 124.343146,48 126,48 L127,48 Z"
          id="Pilcrow"
        />
      </g>
    </g>
  </svg>
);